module.exports = __webpack_public_path__ + "static/logo-c092a3e631b9cc32b47ed97ab9393ded.png";